import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './App.css';

function VideoPage({ videos }) {
  const { videoId } = useParams();
  // Find the index of the current video
  const currentIndex = videos.findIndex((video) => video.id === videoId);
  // Find the current video
  const currentVideo = videos.find((video) => video.id === videoId);

  // Build episodeTitle using the index
  const episodeTitle =
    currentIndex === 12 ? 'Interlude' : `Episode ${currentIndex + 1}`;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [videoId]);

  if (!currentVideo) {
    return <div className='video-not-found'>Video not found</div>;
  }

  const videoStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: episodeTitle,
    description: `This is a Work of Fiction - ${episodeTitle}`,
    thumbnailUrl: `https://img.youtube.com/vi/${currentVideo.id}/maxresdefault.jpg`,
    uploadDate: new Date().toISOString(),
    embedUrl: `https://www.youtube.com/embed/${currentVideo.id}`,
    contentUrl: `https://www.youtube.com/watch?v=${currentVideo.id}`,
  };

  return (
    <div className='video-page'>
      <Helmet>
        <title>{episodeTitle} - This is a Work of Fiction</title>
        <meta
          name='description'
          content={`This is a Work of Fiction - ${episodeTitle}. A series about a woman who gives herself a year to decide if life is worth living.`}
        />
        <script type='application/ld+json'>
          {JSON.stringify(videoStructuredData)}
        </script>
      </Helmet>

      <div className='video-container'>
        <div className='responsive-video-wrapper'>
          <iframe
            title={episodeTitle}
            src={`https://www.youtube.com/embed/${currentVideo.id}`}
            frameBorder='0'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
            allowFullScreen
          ></iframe>
        </div>
      </div>

      <div className='video-info'>
        <h1>{episodeTitle}</h1>
        <p>
          A series about a woman who gives herself a year to decide if life is
          worth living.
        </p>
      </div>

      <div className='navigation'>
        <Link to='/' className='back-button'>
          Back to All Episodes
        </Link>
      </div>
    </div>
  );
}

export default VideoPage;
